import type { PartnerCreate } from "@/types";
import { validateRequired } from "../helpers/validationHelpers";

export const validatePartners = (values: PartnerCreate): Record<string, string> => {
  const errors: Record<string, string> = {};

  // --- Required Top-Level Fields (per backend validation) ---
  validateRequired(values.partner_company_name, "partner_company_name", errors);
  validateRequired(values.partner_code, "partner_code", errors);
  validateRequired(values.domain, "domain", errors);

  // --- Business Logic Validations ---

  // partner_code must be exactly 4 characters
  if (values.partner_code && values.partner_code.length !== 4) {
    errors["partner_code"] = "Partner code must be exactly 4 characters";
  }

  // Note: All other fields are optional per backend (omitempty)
  // status defaults to PartnerStatus.PENDING if not provided

  return errors;
};
